export default {
  trainingDataHeadline: 'Training data',
  outputDataHeadline: 'Original vs. prediction',
  inputDataHeadline: 'Input data',
  modelConfigHeadline: 'Modelparameters',
};
